const compareText = (a, b) =>
  String(a || "").localeCompare(String(b || ""), undefined, { sensitivity: "base" });

// Default round-applicants order: role, then applicant name within a role.
export const compareApplicantRows = (rowA, rowB) =>
  compareText(rowA.role, rowB.role) || compareText(rowA.applicantName, rowB.applicantName);

const compareByApplicantName = (rowA, rowB) =>
  compareText(rowA.applicantName, rowB.applicantName) || compareText(rowA.role, rowB.role);

const ROW_COMPARATORS_BY_FIELD = {
  role: compareApplicantRows,
  applicantName: compareByApplicantName,
};

export const DEFAULT_APPLICANT_SORT_MODEL = [{ field: "role", sort: "asc" }];

// Applies the same role/name comparators the table columns advertise, but over
// the full (pre-pagination) row set — the grid itself only ever sees one page,
// so sorting must happen here, not inside the DataGrid.
export const sortApplicantRows = (rows, sortModel) => {
  const [primary] = sortModel || [];
  if (!primary) return [...rows].sort(compareApplicantRows);

  const comparator = ROW_COMPARATORS_BY_FIELD[primary.field] || compareApplicantRows;
  const sorted = [...rows].sort(comparator);
  return primary.sort === "desc" ? sorted.reverse() : sorted;
};

export const roleSortComparator = (v1, v2, cellParams1, cellParams2) =>
  compareApplicantRows(
    cellParams1.api.getRow(cellParams1.id),
    cellParams2.api.getRow(cellParams2.id),
  );

export const applicantNameSortComparator = (v1, v2, cellParams1, cellParams2) =>
  compareByApplicantName(
    cellParams1.api.getRow(cellParams1.id),
    cellParams2.api.getRow(cellParams2.id),
  );
